<!--
  @Description 高级查找组件（待完善）
  @Date 2021-12-23
  @Author liushuo
-->
<template>
  <div class="search-container">
    <!-- 输入框 -->
    <div class="input-dv">
      <el-row> 查找面板 </el-row>
    </div>
    <!-- 已保存方案 -->
    <div class="save-plan-dv">已保存方案</div>
  </div>
</template>

<script>
export default {
  name: 'SearchForm',
  data () {
    return {
    }
  }
}
</script>

<style lang="less" scoped>
// 方案容器宽度
@plan-width: 300px;

.search-container {
  height: 100%;
  width: 100%;
  display: flex;
  border-radius: 10px;
  background-color: #ffffff;
  box-shadow: #bebebe 2px 2px 10px;

  .input-dv {
    width: calc(100% - @plan-width);
    height: 100%;
    background-color: #ebebeb;
    .fl;
  }

  .save-plan-dv {
    width: 300px;
    height: 100%;
    background-color: #f2f3f5;
    .fl;
  }
}
</style>
